import * as React from 'react';
import { DataChangeHistoryViewPanelControl } from './DataChangeHistoryViewPanel';
export const DataChangeHistoryStatusBarContent = () => {
    return React.createElement(DataChangeHistoryViewPanelControl, { gap: 0, buttonsPaddingY: 0 });
};
